var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogoutHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "18px",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLogoutHeader") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final-Home-with-submenu",
    transform: "translate(-1099.000000, -302.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(1079.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom",
    transform: "translate(0.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(20.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(8.500000, 9.000000) rotate(-90.000000) translate(-8.500000, -9.000000) translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3105703,7.27145117 C16.5781527,7.32999118 16.7119348,7.49601234 16.7119166,7.76951465 C16.7118984,8.04301696 16.5780941,8.20903812 16.3105039,8.26757813 L7.57682031,8.26757813 C7.30176562,8.26757813 7.07874023,8.04461914 7.07874023,7.76953125 C7.07874023,7.49444336 7.30176562,7.27145117 7.57682031,7.27145117 L16.3105703,7.27145117 Z M14.2929824,10.9675566 C14.531082,11.1053164 14.6124297,11.4099883 14.4747363,11.6480879 C13.1297109,13.9732031 10.6172305,15.5258809 7.75634961,15.5258809 C3.4690293,15.5258809 1.15463195e-14,12.0564863 1.15463195e-14,7.76953125 C1.15463195e-14,3.48221094 3.46939453,0.0131816406 7.75634961,0.0131816406 C10.616002,0.0131816406 13.1291133,1.56476367 14.4747031,3.8909082 C14.6123965,4.12900781 14.5310488,4.43371289 14.2929492,4.57143945 C14.0549492,4.70906641 13.7501445,4.62781836 13.612418,4.38968555 C12.4431699,2.36841211 10.2571758,1.00930859 7.75634961,1.00930859 C4.02876758,1.00930859 0.996126953,4.04194922 0.996126953,7.76953125 C0.996126953,11.4971133 4.02876758,14.5297539 7.75634961,14.5297539 C10.2555156,14.5297539 12.4425059,13.1719121 13.6124512,11.1493105 C13.7502109,10.9111777 14.0549492,10.8298965 14.2929824,10.9675566 Z",
    id: "icLogoutHeader"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogoutHeader);
export default __webpack_public_path__ + "static/media/icLogoutHeader.4a882e567dba029bf58f646ce77858f9.svg";
export { ForwardRef as ReactComponent };